import React from "react";
import Secondary from "../buttons/secondary/Secondary";
import "./Project.css";

const Project = ({ project, i }) => {
  const toGithub = () => {
    window.open(project.github, "_blank");
  };

  return (
    <article className="project" data-attr={i}>
      <div className="col-1">
        <a href={project.demo} target="_blank" rel="noreferrer">
          <div className="backdrop">
            <div>
              <h1 className="backdrop__text">Live Demo</h1>
            </div>
          </div>
        </a>
        <picture>
          <source
            media="(min-width: 1110px)"
            srcSet={project.preview.desktop}
          />
          <source media="(min-width: 688px)" srcSet={project.preview.tablet} />
          <img src={project.preview.mobile} className="project__preview" />
        </picture>
      </div>
      <div className="col-2">
        <div className="project--box-2">
          <div>
            <h2 className="h2 project__name">{project.name}</h2>
          </div>
          <div>
            <p className="body-2 project__description">{project.description}</p>
          </div>
          <div className="project--box-1">
            <ul className="project__tools">
              {project.tools.map((tool, index) => (
                <li key={tool}>
                  <div className="project__tool body-2 project__tool--styling">
                    {tool}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="project--box-3">
            <Secondary text={"view project"} action={toGithub} />
          </div>
        </div>
      </div>
    </article>
  );
};

export default Project;
